import Api from './api';

export default {
  login: (email, password) => Api.post('login', { email, password }),
  logout: () => Api.post('logout'),
  refreshToken: (token) => Api.post('login/refresh', { token }),
};
